"use strict";
//@ts-nocheck
/**
 * Top cart/serach actions
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
const _main_1 = require("./_main");
_main_1.txGs1Base.download = {
    initialize: function () {
        'use strict';
        var $dlwrapper = $('.tx-gs1base-pi-dlwrapper'), $content, $confirmTermsOfUseHeadline, $cancelButton;
        if ($dlwrapper.length > 0) {
            $confirmTermsOfUseHeadline = $dlwrapper.find('[data-confirm-headline-uri]');
            if ($confirmTermsOfUseHeadline.length > 0) {
                $content = $('<div class="box"></div>').prepend($dlwrapper.clone());
                $content.prepend($('<h1></h1>').text($confirmTermsOfUseHeadline.attr('data-confirm-headline-uri')));
            }
            else {
                $content = $dlwrapper.parent().clone().addClass('box');
            }
            $.fancybox({
                type: 'html',
                content: $content,
                live: false,
                margin: 0,
                padding: 50,
                openMethod: 'modalIn',
                minWidth: 350,
                maxWidth: 800,
                tpl: {
                    wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin modal-dialog"><div class="fancybox-outer modal-content"><div class="fancybox-inner modal-body"></div></div></div></div>',
                    error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                    closeBtn: '<button class="fancybox-item fancybox-close close"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>'
                },
                helpers: {
                    title: {
                        type: 'inside',
                        position: 'bottom'
                    },
                    overlay: {
                        locked: false
                    }
                },
                afterShow: function () {
                    $('.modal-dialog').animate({
                        top: 0,
                        opacity: 1
                    }, 500);
                    // Quick Fix: Do not attach throbber for Safari because it causes a complete freeze
                    // in combination with active scriptmerger
                    // ToDo: Find and resolve causation
                    var agent = navigator.userAgent.toLowerCase();
                    if (agent.indexOf('safari') < 0 && $confirmTermsOfUseHeadline.length === 0) {
                        $content.find('h1').attachThrobber();
                    }
                }
            });
        }
    }
};
exports.default = {};
